import React, { useEffect, useState } from 'react';
import { api, errText } from '../api.js';

export default function AdminCountries() {
  const [list, setList] = useState(null);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState('');

  const load = () => api('/api/admin/countries').then(setList).catch((e) => setErr(errText(e)));
  useEffect(() => { load(); }, []);

  async function save(country, body) {
    setErr(''); setMsg('');
    try {
      await api(`/api/admin/countries/${country}`, { method: 'PUT', body });
      setMsg(`${country} güncellendi`);
      load();
    } catch (e) {
      setErr(errText(e));
      load(); // sunucu reddettiyse ekranı gerçeğe çek
    }
  }

  if (err && !list) return <p className="err">{err}</p>;
  if (!list) return <p className="muted">yükleniyor…</p>;

  return (
    <div className="card">
      <h2>Ülke uygunluğu</h2>
      <p className="muted" style={{ marginTop: 0 }}>
        <b>Fiskalizasyon kapısı:</b> sertifikalı kasa isteyen ülke (Almanya TSE,
        Avusturya RKSV, İtalya RT, Fransa NF525, Portekiz SAF-T) sağlayıcı
        entegre edilmeden satışa açılamaz. Açmak için önce "fiskalizasyon"
        kutusunu bilinçli olarak kaldırman gerekir.
      </p>
      <table>
        <thead>
          <tr><th>Ülke</th><th>Para birimi</th><th>KDV</th><th>Fiskalizasyon</th><th>Satışa açık</th><th>Not</th></tr>
        </thead>
        <tbody>
          {list.map((c) => (
            <tr key={c.country}>
              <td><b>{c.country}</b></td>
              <td>{c.currency}</td>
              <td>%{(c.vatDefault / 100).toFixed(2)}</td>
              <td>
                <div className="switch">
                  <input type="checkbox" checked={c.fiscalizationRequired}
                    onChange={(e) => save(c.country, { fiscalizationRequired: e.target.checked })} />
                  {c.fiscalizationRequired && <span className="badge warn">gerekli</span>}
                </div>
              </td>
              <td>
                <div className="switch">
                  <input type="checkbox" checked={c.available}
                    onChange={(e) => save(c.country, { available: e.target.checked })} />
                  {c.available ? <span className="badge ok">açık</span> : <span className="badge">kapalı</span>}
                </div>
              </td>
              <td className="muted" style={{ fontSize: 12, maxWidth: 280 }}>{c.notes || '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {msg && <p className="ok">{msg}</p>}
      {err && <p className="err">{err}</p>}
    </div>
  );
}
